import { getApi } from '../../utils/api'

export function getEmailAccounts() {
  return getApi({
    endpoint: '/api/mail-account/simple/',
    params: {
      is_active: true,
      service: true,
    },
  })
}
